<div  class="d-flex">
  <div class="col" [ngClass]="{ 'col-sm-6 col-md-8': !isUserLoggedIn }">
    <div class="card">
      <h4 class="card-header">Home page</h4>
      <div class="card-body">
        <h4 style="background: none; border: none; padding: 0; margin-bottom: 1rem; color: inherit;">Welcome to the BCF Credit Portal</h4>
        <p>The portal provides a secure place where you can see all your applications and documents.</p>
        <p>You can use the tabs at the top of this page to:</p>

        <ul>
          <li>
            Check your <strong>account details.</strong>
          </li>
          <li>
            Make an <strong>offset payment.</strong>
            <p>From this tab you can request a quote or apply to make a payment into the Biodiversity Conservation Fund.<br/>
            The <a href="javascript:void(0)" style="text-decoration: underline; cursor: pointer;">Pay into the Biodiversity Conservation Fund</a> webpage gives an overview of the documents you need to request a quote or payment.</p>
          </li>
          <li>
            Submit a <strong>credit offer.</strong>
            <p>
              From this tab you can offer to sell your credits to the BCT, either through a credit tender or other programs.
            <br/>
            The <a href="javascript:void(0)" style="text-decoration: underline; cursor: pointer;">Sell your credits to the BCT</a> page gives an overview of what's required.</p>
          </li>
        </ul>
        <br/>
        <p>If you require assistance, email <a href="mailto:offsets@bct.nsw.gov.au">offsets@bct.nsw.gov.au</a></p>
        <br/>
        
      </div>
    </div>
  </div>
  <div *ngIf="!isUserLoggedIn" class="col col-sm-4 col-md1">
    <div class="card">
      <h4 class="card-header">Register / Login</h4>
      <div class="card-body">
        <div class="row col-md-12 col-xs-10 btn-toolbar">
          Please log in to the Credit Portal to:
          <ul>
            <li>Request a Biodiversity Conservation Fund quote,</li>
            <li>Make a payment into the Biodiversity Conservation Fund, or</li>
            <li>Submit a credit offer in a BCT Credit Tender. </li>
          </ul>
          Please create an account for the Credit Portal via the 'Register' link below.
          <div class="row col-md-12 mt-3">
            <button class="btn btn-primary" (click)="login()">Register / Login</button>
          </div>
          <div class="row col-md-12 mt-3">
          </div>
        </div>        
      </div>
      <div *ngIf="showMaintenance" class="card-footer border border-danger">
    <div class="d-flex align-items-center justify-content-center text-center mb-3">
      <i class="fa fa-wrench fa-2x text-danger mr-2 flex-shrink-0" aria-hidden="true"></i>
      <h3 id="maintenance-title" class="h5 mb-0 text-danger">Under maintenance</h3>
    </div>
    <p>{{ maintenanceMessage }}</p>
    <p *ngIf="maintenanceRetryMessage">{{ maintenanceRetryMessage }}</p>
      </div>
    </div>
  </div>
</div>


